import { render, staticRenderFns } from "./escalationConfirmation.vue?vue&type=template&id=6c524aec&scoped=true"
import script from "./escalationConfirmation.vue?vue&type=script&lang=js"
export * from "./escalationConfirmation.vue?vue&type=script&lang=js"
import style0 from "./escalationConfirmation.vue?vue&type=style&index=0&id=6c524aec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c524aec",
  null
  
)

export default component.exports